import { App } from "components/App";
import ReactDOM from "react-dom";
import { ELEMENT_IDS } from "./constants";
import "./i18n";

ReactDOM.render(<App />, document.getElementById(ELEMENT_IDS.REACT_ROOT));
